<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-6">                
                <div class="row mt-4">
                    <div class="multisteps-form mb-9">
                        <div class="col-12 col-lg-10 m-auto">
                            <div class="card">
                                <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                    <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
                                        <div class="multisteps-form__progress">
                                            <button class="multisteps-form__progress-btn js-active position-relative" type="button">                                                
                                                <span>{{ $t('settings.New_user_manual_type') }}</span>                                                
                                            </button>                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">                                    
                                    <div class="bg-white">
                                        <div class="row mt-4">
                                            <div class="col-12">
                                                <div class="input-group input-group-static null">
                                                    <label>{{ $t('settings.Name') }}</label>
                                                    <input v-model="state.name" type="text" class="form-control form-control-default" placeholder="Name">
                                                    <span v-if="v$.name.$error" class="text-sm text-danger">
                                                            {{ v$.name.$errors[0].$message }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-4">
                                            <div class="col-4">
                                                <div class="input-group input-group-static null">
                                                    <label class="d-block mb-1" style="width: inherit;">{{ $t('settings.IsGlobal') }}</label>
                                                    <div class="d-block mt-1">
                                                    <material-switch v-model="state.isGlobal" id="isGlobal" name="isGlobal" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="button-row d-flex mt-4">
                                        <router-link to="/settings" class="btn btn-sm bg-gradient-danger float-start">{{ $t('common.Cancel') }}</router-link>
                                        <button @click="saveForm" class="btn btn-sm bg-gradient-success ms-auto" type="button">{{ $t('common.Save') }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import axios from 'axios'
import useValidate from '@vuelidate/core'
import { required, helpers, } from '@vuelidate/validators'
import { reactive, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import MaterialSwitch from "@/components/MaterialSwitch.vue";

    export default {
        name: 'UserManualType_create_page',

        setup() {

        const { t } = useI18n()

        const state = reactive ({
            name: '',
            isGlobal: false,
        })
        
        const rules = computed(() => {
            return {
                name: { required: helpers.withMessage(t('common.Required'), required) }
            }
        })  
        
        const v$ = useValidate(rules, state)

        return {
            state,
            v$
        }
    },
    components: {
        MaterialSwitch
    },    
    async mounted() {        
    },
        methods: {  
            
            async saveForm() {
                this.submitForm();
            },           
            async submitForm() {                
                // Put create logic
                try {                    
                    // Trigger form validation
                    const isValid = await this.v$.$validate();

                    if (!isValid) {
                        //console.log('Validation failed');
                        return;
                    } 
                    
                    this.$store.commit('setShowLoading', true);

                    const response = await axios.post('UserManualType/save', {                                                      
                        "name": this.state.name,
                        "isGlobal": this.state.isGlobal
                    });
                    this.gets = response.data;

                    if (this.gets.success) {
                        this.$showSuccess('errors.Success_user_manual_type_created_successfully');
                        this.$router.push('/settings');
                    } else {
                        this.$showError('errors.Contact_system_admin');
                    }
                }
                catch(e) {
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                }
                
                this.$store.commit('setShowLoading', false);
            }
        }
    }
</script>
<style scoped>  
    .multisteps-form__progress-btn.js-active span {
        color: #fff !important;  
    }
</style>